// AI-tinted insight panel for /analytics/mission-impact and /executive.
// recommendations: [{ id, title, body, impact: 'high'|'med'|'low', actionLabel?, onAction? }]

const IMPACT_TONE = { high: 'red', med: 'amber', low: 'sage' };

export function AiRecommendationCard({
  title = 'AI Reallocation Advisor',
  subtitle = 'Pending human review',
  recommendations = [],
  onAccept,
  onDismiss,
}) {
  return (
    <section className="ai-recommendation-card">
      <span className="ai-recommendation-ghost" aria-hidden>
        ✦
      </span>
      <header>
        <div className="eyebrow">AI Insight</div>
        <h3 className="card-title">{title}</h3>
        <span className="chip outline sm">{subtitle}</span>
      </header>
      <ol className="ai-recommendation-list">
        {recommendations.length === 0 ? (
          <li className="empty-state" style={{ padding: 'var(--space-4)' }}>
            <p style={{ margin: 0 }}>The advisor has not produced any recommendations yet.</p>
          </li>
        ) : null}
        {recommendations.map((r) => (
          <li
            key={r.id}
            className={`ai-recommendation-row impact-${IMPACT_TONE[r.impact] || 'blue'}`}
          >
            <span className="ai-recommendation-glyph" aria-hidden>
              {r.impact === 'high' ? '!' : r.impact === 'med' ? '◆' : '•'}
            </span>
            <div className="stack tight">
              <strong>{r.title}</strong>
              <p>{r.body}</p>
              <div className="row" style={{ gap: 8 }}>
                {r.actionLabel ? (
                  <button
                    className="btn link"
                    onClick={() => (r.onAction ? r.onAction(r) : onAccept && onAccept(r))}
                  >
                    {r.actionLabel} →
                  </button>
                ) : null}
                <button className="btn link muted" onClick={() => onDismiss && onDismiss(r)}>
                  Dismiss
                </button>
              </div>
            </div>
          </li>
        ))}
      </ol>
    </section>
  );
}
